import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OzowPaymentUpdateRequest } from 'src/app/interfaces/ozow/ozow';
import { OzowService } from 'src/app/services/ozow/ozow.service';
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'app-ozow-callback-version-two',
  templateUrl: './ozow-callback.component.html',
  styleUrls: ['./ozow-callback.component.scss']
})
export class OzowCallbackComponent implements OnInit {
  ozowPaymentUpdateRequest: OzowPaymentUpdateRequest
  confirmed: boolean = false;
  mobile;

  constructor(
    private route: ActivatedRoute, 
    private ozowService: OzowService, 
    private router: Router, 
    private breakpointObserver: BreakpointObserver,
    private sessionService: SessionService
  ) {
    this.breakpointObserver.observe([
      Breakpoints.HandsetLandscape,
      Breakpoints.HandsetPortrait
    ]).subscribe(result => {
      this.mobile = result.matches;
    });
   }

  ngOnInit(): void {
    this.route.queryParams
      .subscribe(params => {
        this.ozowPaymentUpdateRequest = {
          siteCode: params.SiteCode,
          transactionId: params.TransactionId,
          transactionReference: params.TransactionReference,
          amount: params.Amount,
          status: params.Status,
          currencyCode: params.CurrencyCode,
          isTest: params.IsTest,
          statusMessage: params.StatusMessage,
          bankName: params.BankName,
          hash: params.Hash
        };

        this.sendPostbackMessage();
      }
    );
  }

  private sendPostbackMessage() {
    window.parent.postMessage({
      payload:this.ozowPaymentUpdateRequest,
      status: 'COMPLETED',
      paymethod: 'OZOW'
    }, `${window.location.protocol}//${window.location.host}`);
  }
}
